var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TableAudit',{attrs:{"table-title":'Completed',"api-url-props":_vm.apiUrl,"columns":_vm.columns,"top-header":_vm.topHeader}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }